/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_EXPENSE,
  READ_EXPENSE_LIST,
  CREATE_EXPENSE,
  getExpenseListUrl,
  getExpenseRouterPath,
  useExpenseRoute,
} from 'domain/shared/expense';
import ExpenseList from 'domain/finance/expenses/List';
import ExpenseViewPage from 'domain/finance/expenses/Show';
import ExpenseCreatePage from 'domain/finance/expenses/createupdate/Create';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import UploadExpensesPage from './uploadExpenses/UploadExpensesPage';

const ExpenseRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute, createRoute: createExpenseRoute, uploadExpensesRoute } = useExpenseRoute();

  return (
    <ProtectedRouter basePath={getExpenseListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_EXPENSE_LIST}>
              <ExpenseList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createExpenseRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_EXPENSE}>
              <ExpenseCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={uploadExpensesRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_EXPENSE}>
              <UploadExpensesPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_EXPENSE}>
              <ExpenseViewPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ExpenseRouter.getRouterPath = getExpenseRouterPath;

export default ExpenseRouter;
